import type {
  CreateRecipientGroupRequest,
  RecipientGroupSummary,
  UpdateRecipientGroupRequest,
} from '@todo/shared';
import { del, get, patch, post } from './client';

/**
 * /api/recipient-groups - named lists of people to invite.
 *
 * Reading is open to every signed-in user, because the meeting form's
 * dropdown needs it. Writing is ADMIN / SUPER_ADMIN and will 403
 * otherwise, so the Settings panel is the only caller of the write
 * methods.
 *
 * Every response carries `members` in full. That is deliberate: the
 * meeting form merges a group's member ids into the attendee selection the
 * instant it is picked, and a per-group round trip at that moment would
 * put a spinner in the middle of filling in a form.
 */
export const recipientGroupApi = {
  list(): Promise<RecipientGroupSummary[]> {
    return get<RecipientGroupSummary[]>('/recipient-groups');
  },

  create(body: CreateRecipientGroupRequest): Promise<RecipientGroupSummary> {
    return post<RecipientGroupSummary>('/recipient-groups', body);
  },

  /** `userIds` present REPLACES the membership; absent leaves it alone. */
  update(id: string, body: UpdateRecipientGroupRequest): Promise<RecipientGroupSummary> {
    return patch<RecipientGroupSummary>(`/recipient-groups/${id}`, body);
  },

  /** Soft delete. Meetings already created keep their attendees. */
  remove(id: string): Promise<void> {
    return del(`/recipient-groups/${id}`);
  },
};
